import { NgModule } from '@angular/core';
import { PropositionSliderComponent } from './components/proposition-slider/proposition-slider.component';
import { PropositionComponent } from './components/proposition/proposition.component';

import { WiseeComponent } from './components/wisee/wisee.component';
import { PropositionCommentComponent } from './components/proposition-comment/proposition-comment.component';
import { PropositionCommentReplyComponent } from './components/proposition-comment-reply/proposition-comment-reply.component';
import { PropositionMenuComponent } from './components/proposition-menu/proposition-menu.component';
import { ThinkTankPropositionDialogComponent } from './dialogs/think-tank-proposition-dialog/think-tank-proposition-dialog.component';
import { CommentComponent } from './components/comment/comment.component';
import { ReplyComponent } from './components/reply/reply.component';
import { AtDatePipe } from './pipes/at-date.pipe';
import { AtTimePipe } from './pipes/at-time.pipe';
import { KiloformatterPipe } from './pipes/kiloformatter.pipe';
import { LimitcharacterPipe } from './pipes/limitcharacter.pipe';
import { OptionSelectedPipe } from './pipes/option-selected.pipe';
import { ThousandPipe } from './pipes/thousand.pipe';
import { TimeAgoPipe } from './pipes/timeago.pipe';
import { UsernamePipe } from './pipes/username.pipe';
import { IconComponentName } from './components/icon-name/icon-name.component';
import { FirstPipe } from '@pipes/first.pipe';
import { IsNotPipe } from '@pipes/is-not.pipe';
import { IsPipe } from '@pipes/is.pipe';
import { Nl2brPipe } from '@pipes/nl2br.pipe';
import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { QuillModule } from 'ngx-quill';
import { MentionModule } from 'angular-mentions';
import { NgxEchartsModule } from 'ngx-echarts';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModalInsertionDirective } from '@directives/modal-insertion.directive';
import { CountUpDirective } from '@directives/countup.directive';
import { EllipsisDirective } from '@directives/ellipsis.directive';
import { AvatarComponent } from '@components/common/avatar/avatar.component';
import { BadgeComponent } from '@components/common/badge/badge.component';
import { BoxComponent } from '@components/common/box/box.component';
import { ButtonComponent } from '@components/common/button/button.component';
import { IconSvgComponent } from '@components/common/icon-svg/icon-svg.component';
import { IdenticonComponent } from '@components/common/identicon/identicon.component';
import { LoaderInlineComponent } from '@components/common/loader-inline/loader-inline.component';
import { NavigationComponent } from '@components/common/navigation/navigation.component';
import { OptionsMenuItemComponent } from '@components/common/options-menu-item/options-menu-item.component';
import { OptionsMenuComponent } from '@components/common/options-menu/options-menu.component';
import { PageLoaderComponent } from '@components/common/page-loader/page-loader.component';
import { PaginationComponent } from '@components/common/pagination/pagination.component';
import { RangeSliderComponent } from '@components/common/range-slider/range-slider.component';
import { SliderDisplayComponent } from '@components/common/slider-display/slider-display.component';
import { SliderComponent } from '@components/common/slider/slider.component';
import { SpinnerComponent } from '@components/common/spinner/spinner.component';
import { Spinner1Component } from '@components/common/spinner1/spinner1.component';
import { VoteComponent } from '@components/common/vote/vote.component';
import { MembershipItemComponent } from '@components/core/membership-item/membership-item.component';
import { NftItemComponent } from '@components/core/nft-item/nft-item.component';
import { CardCheckboxComponent } from '@components/form/card-checkbox/card-checkbox.component';
import { CardRadioComponent } from '@components/form/card-radio/card-radio.component';
import { ChipGroupComponent } from '@components/form/chip-group/chip-group.component';
import { ChipSelectionComponent } from '@components/form/chip-selection/chip-selection.component';
import { DateComponent } from '@components/form/date/date.component';
import { DropdownAutocompleteComponent } from '@components/form/dropdown-autocomplete/dropdown-autocomplete.component';
import { DropdownOptionsComponent } from '@components/form/dropdown-options/dropdown-options.component';
import { DropdownSelectionComponent } from '@components/form/dropdown-selection/dropdown-selection.component';
import { DropdownComponent } from '@components/form/dropdown/dropdown.component';
import { FieldChipComponent } from '@components/form/field-chip/field-chip.component';
import { InputExpandComponent } from '@components/form/input-expand/input-expand.component';
import { InputSearchComponent } from '@components/form/input-search/input-search.component';
import { InputComponent } from '@components/form/input/input.component';
import { MultiSelectionComponent } from '@components/form/multi-selection/multi-selection.component';
import { RadioGroupComponent } from '@components/form/radio-group/radio-group.component';
import { SearchSelectionComponent } from '@components/form/search-selection/search-selection.component';
import { SearchComponent } from '@components/form/search/search.component';
import { SwitchComponent } from '@components/form/switch/switch.component';
import { TextareaComponent } from '@components/form/textarea/textarea.component';
import { ValueModalComponent } from '@components/form/value-modal/value-modal.component';
import { PostActionBarComponent } from '@components/forum/post-action-bar/post-action-bar.component';
import { PostAuthorComponent } from '@components/forum/post-author/post-author.component';
import { PostCommentComponent } from '@components/forum/post-comment/post-comment.component';
import { PostCommentsSectionComponent } from '@components/forum/post-comments-section/post-comments-section.component';
import { PostContainerHeaderComponent } from '@components/forum/post-container-header/post-container-header.component';
import { PostContainerComponent } from '@components/forum/post-container/post-container.component';
import { PostMoreCommentsComponent } from '@components/forum/post-more-comments/post-more-comments.component';
import { PostPublishComponent } from '@components/forum/post-publish/post-publish.component';
import { PostReplyLineComponent } from '@components/forum/post-reply-line/post-reply-line.component';
import { PostUserOptionsComponent } from '@components/forum/post-user-options/post-user-options.component';
import { PostCoverSelectionComponent } from '@components/modals/forum/post-cover-selection/post-cover-selection.component';
import { OnboardingComponent } from '@components/modals/membership/onboarding/onboarding.component';
import { NftConfirmComponent } from '@components/modals/nft/nft-confirm/nft-confirm.component';
import { ValueImportanceComponent } from '@components/modals/value-importance/value-importance.component';
import { SelectCheckboxComponent } from '@components/ui/select-checkbox/select-checkbox.component';
import { UiBlurComponent } from '@components/ui/ui-blur/ui-blur.component';
import { UiChipComponent } from '@components/ui/ui-chip/ui-chip.component';
import { UiOgArticleComponent } from '@components/ui/ui-og/ui-og-article/ui-og-article.component';
import { UiPostTextComponent } from '@components/ui/ui-post/ui-post-text/ui-post-text.component';
import { UiRatingComponent } from '@components/ui/ui-rating/ui-rating.component';
import { UiSelectComponent } from '@components/ui/ui-select/ui-select.component';
import { UiStartComponent } from '@components/ui/ui-star/ui-star.component';
import { UiToggleComponent } from '@components/ui/ui-toggle/ui-toggle.component';
import { UiVoteComponent } from '@components/ui/ui-vote/ui-vote.component';
import { IconComponent } from '@components/common/icon/icon.component';
import { CheckboxComponent } from '@components/form/checkbox/checkbox.component';
import { RadioComponent } from '@components/form/radio/radio.component';
import { ChipComponent } from '@components/form/chip/chip.component';
import { ChipComponent as ChipComponentNew } from './components/chip/chip.component';
import { NftErrorComponent } from '@components/modals/nft/nft-error/nft-error.component';
import { PostDeleteComponent } from '@components/modals/forum/post-delete/post-delete.component';
import { PostDeleteCommentComponent } from '@components/modals/forum/post-delete-comment/post-delete-comment.component';
import { PostHideComponent } from '@components/modals/forum/post-hide/post-hide.component';
import { UiPostComponent } from '@components/ui/ui-post/ui-post.component';
import { UiPostWiseeComponent } from '@components/ui/ui-post/ui-post-wisee/ui-post-wisee.component';
import { UiOgComponent } from '@components/ui/ui-og/ui-og.component';
import { ModalComponent } from '@components/common/modal/modal.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AnyPipe } from '@pipes/any.pipe';
import { LinksPipe } from '@pipes/links.pipe';
import { IonInput, IonicModule } from '@ionic/angular';
import { PageContentComponent } from './pages/page-content/page-content.component';
import { LessThanArrayPipe } from '@pipes/less-than-array.pipe';
import { LessOrEqualThanArrayPipe } from '@pipes/less-or-equal-than-array.pipe';
import { TakePipe } from '@pipes/take.pipe';
import { ReplaceWithPipe } from '@pipes/replace-if.pipe';
import { PropositionNotificationComponent } from './components/proposition-notification/proposition-notification.component';
import { UiSwitchComponent } from '@components/ui/ui-switch/ui-switch.component';
import { MarketSectorsPopoverComponent } from './components/market-sectors-popover/market-sectors-popover.component';
import { BoostModalComponent } from './modals/boost-modal/boost-modal.component';
import { ShareModalComponent } from './modals/share-modal/share-modal.component';
import { ArkiusShareModalComponent } from './modals/arkius-share-modal/arkius-share-modal.component';
import { ThankYouModalComponent } from './modals/thank-you-modal/thank-you-modal.component';
import { FounderInvitationSuccessModalComponent } from './modals/founder-invitation-success-modal/founder-invitation-success-modal.component';
import { RopModalComponent } from './modals/rop-modal/rop-modal.component';
import { MultiplierModalComponent } from './modals/multiplier-modal/multiplier-modal.component';
import { DeleteModalComponent } from './modals/delete-modal/delete-modal.component';
import { SafeHtmlPipe } from '@pipes/safe-html.pipe';
import { HtmlBlockComponent } from './components/html-block/html-block.component';
import { ModerateModalComponent } from './modals/moderate-modal/moderate-modal.component';
import { ModerateCommentModalComponent } from './modals/moderate-comment-modal/moderate-comment-modal.component';
import { ModerateReplyModalComponent } from './modals/moderate-reply-modal/moderate-reply-modal.component';
import { InvitationModalComponent } from './modals/invitation-modal/invitation-modal.component';
import { InvitationRequestModalComponent } from './modals/invitation-request-modal/invitation-request-modal.component';
import { NumberAbbreviationPipe } from '@pipes/number-abbrevation.pipe';
import { StatsPopoverComponent } from './components/stats-popover/stats-popover.component';
import { ResetPasswordModalComponent } from './modals/reset-password-modal/reset-password-modal.component';
import { ThankYouBoostModalComponent } from './modals/thank-you-boost-modal/thank-you-boost-modal.component';
import { RateModalComponent } from './modals/rate-modal/rate-modal.component';
import { ImageCropComponent } from './components/image-crop/image-crop.component';
import { PlyrVideoComponent } from './components/plyr-video/plyr-video.component';
import { NativeVideoUploadComponent } from './components/native-video-upload/native-video-upload.component';
import { CommitmentFollowModalComponent } from './modals/commitment-follow-modal/commitment-follow-modal.component';
import { UnblockModalComponent } from './modals/unblock-modal/unblock-modal.component';
import { BlockModalComponent } from './modals/block-modal/block-modal.component';
import { ThankYouFeedbackModalComponent } from './modals/thank-you-feedback-modal/thank-you-feedback-modal.component';
import { ThankYouQuestionModalComponent } from './modals/thank-you-question-modal/thank-you-question-modal.component';
import { PiBadgeComponent } from './components/pi-badge/pi-badge.component';
import { UiVoteButtonsComponent } from '@components/ui/ui-vote-buttons/ui-vote-buttons.component';
import { AddCoFounderModalComponent } from './modals/add-co-founder-modal/add-co-founder-modal.component';
import { FoundersBlockComponent } from './components/founders-block/founders-block.component';
import { PiDetailsModalComponent } from './modals/pi-details-modal/pi-details-modal.component';
import { BackingBlockComponent } from './components/backing-block/backing-block.component';
import { OwnershipBlockComponent } from './components/ownership-block/ownership-block.component';
import { SingleFounderInfoModalComponent } from './modals/single-founder-info-modal/single-founder-info-modal.component';
import { MultipleFoundersInfoModalComponent } from './modals/multiple-founders-info-modal/multiple-founders-info-modal.component';
import { AddFounderModalComponent } from './modals/add-founder-modal/add-founder-modal.component';
import { DmCenterDatePipe } from '@pipes/dm-center-date-pipe.pipe';
import { FirstLetterUppercasePipe } from '@pipes/first-letter-uppercase.pipe';
import { SuggestedUsersModalComponent } from './modals/suggested-users-modal/suggested-users-modal.component';
import { DiscoverCardComponent } from './components/discover-card/discover-card.component';

const MODULES = [
  CommonModule,
  FormsModule,
  TranslateModule,
  ReactiveFormsModule,
  InlineSVGModule,
  AngularSvgIconModule,
  RouterModule,
  NgxTippyModule,
  NgClickOutsideDirective,
  IonicModule,
  QuillModule,
  MentionModule,
  NgxEchartsModule.forRoot({
    echarts: () => import('echarts'),
  }),
];
const DIRECTIVES = [
  CountUpDirective,
  EllipsisDirective,
  ModalInsertionDirective,
];
const MODALS = [
  NftConfirmComponent,
  NftErrorComponent,
  OnboardingComponent,
  ValueImportanceComponent,
];

const FORUM = [
  PostActionBarComponent,
  PostAuthorComponent,
  PostCommentComponent,
  PostCommentsSectionComponent,
  PostContainerComponent,
  PostContainerHeaderComponent,
  PostMoreCommentsComponent,
  PostPublishComponent,
  PostReplyLineComponent,
  PostUserOptionsComponent,
  PostCoverSelectionComponent,
  PostDeleteComponent,
  PostDeleteCommentComponent,
  PostHideComponent,
];

const UICOMPONENTS = [
  UiChipComponent,
  UiBlurComponent,
  UiStartComponent,
  UiRatingComponent,

  UiPostComponent,
  UiPostTextComponent,
  UiPostWiseeComponent,

  UiOgComponent,
  UiOgArticleComponent,

  UiSelectComponent,
  UiToggleComponent,
  UiSwitchComponent,
  UiVoteComponent,
  UiVoteButtonsComponent,
];
const COMPONENTS = [
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  IconComponent,
  IconSvgComponent,
  LoaderInlineComponent,
  ModalComponent,
  OptionsMenuItemComponent,
  OptionsMenuComponent,
  SliderComponent,
  SliderDisplayComponent,
  SpinnerComponent,
  VoteComponent,
  PaginationComponent,
  Spinner1Component,
  NftItemComponent,
  MembershipItemComponent,
  PageLoaderComponent,
  BadgeComponent,
  RangeSliderComponent,
  SelectCheckboxComponent,
  IdenticonComponent,
  ...UICOMPONENTS,
  NavigationComponent,
  PageContentComponent,
  MarketSectorsPopoverComponent,
  StatsPopoverComponent,
  PiBadgeComponent,
  FoundersBlockComponent,
  BackingBlockComponent,
  OwnershipBlockComponent,
];
const FORMS = [
  CardCheckboxComponent,
  CardRadioComponent,
  CheckboxComponent,
  ChipComponent,
  ChipGroupComponent,
  ChipSelectionComponent,
  DateComponent,
  DropdownComponent,
  DropdownOptionsComponent,
  DropdownSelectionComponent,
  FieldChipComponent,
  InputComponent,
  InputExpandComponent,
  InputSearchComponent,
  DropdownAutocompleteComponent,
  MultiSelectionComponent,
  RadioComponent,
  RadioGroupComponent,
  SearchComponent,
  SearchSelectionComponent,
  SwitchComponent,
  TextareaComponent,
  ValueModalComponent,
  ResetPasswordModalComponent,
  PiDetailsModalComponent,
  SingleFounderInfoModalComponent,
  MultipleFoundersInfoModalComponent,
];

const DECLARATIONS = [
  ...DIRECTIVES,
  ...COMPONENTS,
  ...FORMS,
  ...MODALS,
  ...FORUM,
];
const IMPORTS = [...MODULES];
const EXPORTS = [...MODULES, ...DIRECTIVES, ...COMPONENTS, ...FORMS, ...MODALS];

const Pipes = [
  AtDatePipe,
  AtTimePipe,
  KiloformatterPipe,
  LimitcharacterPipe,
  OptionSelectedPipe,
  ThousandPipe,
  TimeAgoPipe,
  UsernamePipe,
  FirstPipe,
  IsNotPipe,
  IsPipe,
  Nl2brPipe,
  AnyPipe,
  LinksPipe,
  LessThanArrayPipe,
  LessOrEqualThanArrayPipe,
  TakePipe,
  ReplaceWithPipe,
  SafeHtmlPipe,
  NumberAbbreviationPipe,
  DmCenterDatePipe,
  FirstLetterUppercasePipe,
];

const Components = [
  WiseeComponent,
  CommentComponent,
  DiscoverCardComponent,
  PropositionSliderComponent,
  ReplyComponent,
  ChipComponentNew,
  IconComponentName,
  PropositionComponent,
  PropositionCommentComponent,
  PropositionCommentReplyComponent,
  PropositionMenuComponent,
  ThinkTankPropositionDialogComponent,
  ToolbarComponent,
  PropositionNotificationComponent,
  BoostModalComponent,
  ShareModalComponent,
  ArkiusShareModalComponent,
  ThankYouModalComponent,
  FounderInvitationSuccessModalComponent,
  RopModalComponent,
  MultiplierModalComponent,
  DeleteModalComponent,
  ModerateModalComponent,
  ModerateCommentModalComponent,
  ModerateReplyModalComponent,
  HtmlBlockComponent,
  InvitationModalComponent,
  InvitationRequestModalComponent,
  ThankYouBoostModalComponent,
  RateModalComponent,
  CommitmentFollowModalComponent,
  UnblockModalComponent,
  BlockModalComponent,
  ThankYouFeedbackModalComponent,
  ThankYouQuestionModalComponent,
  AddCoFounderModalComponent,
  AddFounderModalComponent,
  SuggestedUsersModalComponent,
  ImageCropComponent,
  PlyrVideoComponent,
  NativeVideoUploadComponent,
];

@NgModule({
  declarations: [DECLARATIONS, ...Components, ...Pipes],
  imports: [IMPORTS],
  exports: [EXPORTS, ...Components, ...Pipes],
  providers: [provideHttpClient()],
})
export class SharedComponentsModule {}
